import { createStore } from 'satcheljs';
import StorageOptionState from './schema/StorageOptionState';

export default createStore<StorageOptionState>('storageOption', {
    usagePercentage: 0,
    amountUsed: 0,
    usageInBytes: 0,
    sendQuota: { IsUnlimited: true, Value: 0 },
    sendReceiveQuota: { IsUnlimited: false, Value: 0 },
})();
